export const LineIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <polyline
      points="2,17 9,10 14,13 22,4"
      stroke="currentColor"
      strokeWidth={2.6}
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);
